export default __webpack_public_path__ + "static/media/maleicon.d31a90cf.png";